import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-12f9cbd8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "report-container" }
const _hoisted_2 = { class: "report-header" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "Mail Log", -1))
const _hoisted_4 = { class: "report-header-actions" }
const _hoisted_5 = { class: "p-input-icon-left" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "pi pi-search" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Button = _resolveComponent("Button")!
  const _component_ConfirmPopup = _resolveComponent("ConfirmPopup")!
  const _component_Column = _resolveComponent("Column")!
  const _component_DataTable = _resolveComponent("DataTable")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_DataTable, {
      dataKey: "mailLogId",
      class: "report-datatable",
      scrollHeight: "flex",
      stripedRows: "",
      selection: _ctx.selectedRows,
      "onUpdate:selection": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.selectedRows) = $event)),
      currentPageReportTemplate: "Showing {first} to {last} of {totalRecords} entries",
      paginatorTemplate: "FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown",
      rowsPerPageOptions: [10, 25, 50, 100],
      scrollable: true,
      value: _ctx.items,
      paginator: true,
      rows: 25,
      filters: _ctx.filters,
      "onUpdate:filters": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.filters) = $event)),
      loading: _ctx.loading,
      globalFilterFields: _ctx.globalFilter,
      filterDisplay: "row"
    }, {
      header: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("span", _hoisted_5, [
              _hoisted_6,
              _createVNode(_component_InputText, {
                modelValue: _ctx.filters['global'].value,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.filters['global'].value) = $event)),
                placeholder: "Keyword Search"
              }, null, 8, ["modelValue"])
            ]),
            (_ctx.isAdmin)
              ? (_openBlock(), _createBlock(_component_Button, {
                  key: 0,
                  label: _ctx.deleteLabel,
                  icon: "pi pi-trash",
                  disabled: !_ctx.selectedRows || _ctx.selectedRows.length === 0,
                  class: "p-button-danger p-button-outlined",
                  onClick: _ctx.deleteSelected
                }, null, 8, ["label", "disabled", "onClick"]))
              : _createCommentVNode("", true),
            _createVNode(_component_ConfirmPopup)
          ])
        ])
      ]),
      empty: _withCtx(() => [
        _createTextVNode("No mail log entries found.")
      ]),
      loading: _withCtx(() => [
        _createTextVNode("Loading mail log. Please wait.")
      ]),
      default: _withCtx(() => [
        (_ctx.isAdmin)
          ? (_openBlock(), _createBlock(_component_Column, {
              key: 0,
              selectionMode: "multiple",
              headerStyle: "width: 3rem",
              exportable: false
            }))
          : _createCommentVNode("", true),
        _createVNode(_component_Column, {
          field: "sent",
          header: "Sent",
          sortable: true,
          style: {"min-width":"12rem"}
        }, {
          body: _withCtx(({ data }) => [
            _createTextVNode(_toDisplayString(_ctx.formatDate(data.sent)), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_Column, {
          field: "email",
          header: "Email",
          sortable: true,
          style: {"min-width":"14rem"}
        }),
        _createVNode(_component_Column, {
          field: "fullName",
          header: "Full Name",
          sortable: true,
          style: {"min-width":"12rem"}
        }, {
          body: _withCtx(({ data }) => [
            _createTextVNode(_toDisplayString(data.fullName || '-'), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_Column, {
          field: "subject",
          header: "Subject",
          sortable: true,
          style: {"min-width":"16rem"}
        }),
        _createVNode(_component_Column, {
          field: "notes",
          header: "Notes",
          sortable: true,
          style: {"min-width":"12rem"}
        }, {
          body: _withCtx(({ data }) => [
            _createTextVNode(_toDisplayString(data.notes || '-'), 1)
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["selection", "value", "filters", "loading", "globalFilterFields"])
  ]))
}